class WLSBuybox extends HTMLElement {
  constructor() {
    super();
    this.options = this.querySelectorAll(".js-options-wrapper");
    this.addToCart = this.querySelector(".js-add-to-cart-new");
    this.optionsCount = Array.from(this.options).map(
      (wrapper) => wrapper.dataset.defaultOptionId || wrapper.querySelector('.js-option.selected')?.getAttribute('data-id') || wrapper.querySelector('.js-option')?.getAttribute('data-id')
    );
    this.quantityPicker = this.querySelector(".js-quantity");
    this.quantityMinus = this.querySelector(".js-wls-buybox-qty-minus");
    this.quantityPlus = this.querySelector(".js-wls-buybox-qty-plus");
    this.upsellWrapper = this.querySelector(".js-upsell-wrapper");
    this.subscriptionPicker = this.querySelectorAll(
      'input[name="selling-plan"]'
    );
    this.sellingPlans = this.querySelectorAll(".js-selling-plans-wrapper");
    this.price = this.querySelector(".js-price");
    this.comparePrice = this.querySelector(".js-compare-at-price");
    this.sellingPlanSelect = this.querySelector(
      'select[name="selling-plan-id"]'
    );
    this.galleryThumbnails = this.querySelector(
      ".js-wls-buybox-gallery-thumbs"
    );
    this.galleryMain = this.querySelector(".js-wls-buybox-gallery-main");
    this.tabButtons = this.querySelectorAll(".wls-product-tab-button");
    this.tabContents = this.querySelectorAll(".wls-product-tab-content");
  }

  connectedCallback() {
    this.bindEvents();
    this.fetchRecommendations();
    this.initGallery();
    this.initTabs();
    
    // Set initial gallery image after a short delay to ensure everything is loaded
    setTimeout(() => {
      // Try to set initial gallery image
      if (!this.setInitialGalleryImage()) {
        // If failed, try again after gallery is fully initialized
        setTimeout(() => {
          this.setInitialGalleryImage();
        }, 500);
      }
    }, 100);
  }

  bindEvents() {
    if (this.options) {
      this.optionEvents();
    }

    if (this.addToCart) {
      this.addToCart.addEventListener("click", (e) => {
        e.preventDefault();
        this.onAddToCartClick();
      });
    }

    if (this.quantityPicker) {
      if (this.quantityPlus) {
        this.quantityPlus.addEventListener("click", () => {
          let currentValue = parseInt(this.quantityPicker.value) || 0;
          this.quantityPicker.value = currentValue + 1;
          this.addToCart.dataset.quantity = this.quantityPicker.value;
        });
      }
      if (this.quantityMinus) {
        this.quantityMinus.addEventListener("click", () => {
          let currentValue = parseInt(this.quantityPicker.value) || 0;
          if (currentValue > 1) {
            this.quantityPicker.value = currentValue - 1;
            this.addToCart.dataset.quantity = this.quantityPicker.value;
          }
        });
      }
      this.quantityPicker.addEventListener(
        "change",
        this.onQuantityChange.bind(this)
      );
    }

    if (this.subscriptionPicker) {
      this.subscriptionPicker.forEach((picker) => {
        picker.addEventListener("change", (event) => {
          this.onSubscriptionChange(event);
        });
      });
    }

    if (this.sellingPlanSelect) {
      this.sellingPlanSelect.addEventListener("change", (event) => {
        this.onSellingPlanChange();
      });
    }
  }

  setAtcLoading(isLoading, label = 'Updating…') {
    if (!this.addToCart) return;

    if (isLoading) {
      this._atcPrevHTML = this.addToCart.innerHTML;
      this.addToCart.classList.add('is-updating');
      this.addToCart.setAttribute('disabled', 'disabled');
      this.addToCart.innerHTML = `
        <svg class="wls-buybox__button-loader" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2391_2305)"><rect x="5.83984" y="18.5684" width="2.25" height="2.25" rx="1.125" transform="rotate(-45 5.83984 18.5684)" fill="white"/></g>
          <g clip-path="url(#clip1_2391_2305)"><rect x="11.873" y="22.0015" width="2.25" height="2.25" rx="1.125" transform="rotate(-90 11.873 22.0015)" fill="white"/></g>
          <g clip-path="url(#clip2_2391_2305)"><rect x="18.5703" y="20.1594" width="2.25" height="2.25" rx="1.125" transform="rotate(-135 18.5703 20.1594)" fill="white"/></g>
          <g clip-path="url(#clip3_2391_2305)"><rect x="22.002" y="14.1265" width="2.25" height="2.25" rx="1.125" transform="rotate(-180 22.002 14.1265)" fill="white"/></g>
          <g clip-path="url(#clip4_2391_2305)"><rect x="20.1602" y="7.43164" width="2.25" height="2.25" rx="1.125" transform="rotate(135 20.1602 7.43164)" fill="white"/></g>
          <g clip-path="url(#clip5_2391_2305)"><rect x="14.123" y="4.00146" width="2.25" height="2.25" rx="1.125" transform="rotate(90 14.123 4.00146)" fill="#F1D077"/></g>
          <g clip-path="url(#clip6_2391_2305)"><rect x="7.43359" y="5.84033" width="2.25" height="2.25" rx="1.125" transform="rotate(45 7.43359 5.84033)" fill="white"/></g>
          <g clip-path="url(#clip7_2391_2305)"><rect x="4.00195" y="11.8765" width="2.25" height="2.25" rx="1.125" fill="white"/></g>
        </svg>
        <span>${label}</span>
      `;
    } else {
      this.addToCart.classList.remove('is-updating');
      this.addToCart.removeAttribute('disabled');
      if (this._atcPrevHTML) {
        this.addToCart.innerHTML = this._atcPrevHTML;
        this._atcPrevHTML = null;
      }
    }
  }


  optionEvents() {
    this.options.forEach((optionWrapper, index) => {
      const options = optionWrapper.querySelectorAll(".js-option");
      options.forEach((option) => {
        option.addEventListener("click", (event) => {
          event.preventDefault();

          // Handle both radio inputs (for Size) and divs (for Color)
          const input = option.querySelector("input[type='radio']");
          if (input) {
            // Size options with radio inputs
            options.forEach(o => {
              const i = o.querySelector("input[type='radio']");
              if (i) i.checked = false;
              o.classList.remove("selected");
            });
            input.checked = true;
            option.classList.add("selected");
          } else {
            // Color options without radio inputs
            options.forEach(opt => opt.classList.remove("selected"));
            option.classList.add("selected");
          }

          const imgEl = option;

          let fileName = null;

          if (imgEl && imgEl.dataset.imgSrc && imgEl.dataset.imgSrc !== 'null' && imgEl.dataset.imgSrc !== '') {
            const optionURL = imgEl.dataset.imgSrc.replace(
              /(&|\?)width=\d+/,
              ""
            );
            const cleanSrc = optionURL.split("?")[0];
            fileName = cleanSrc.split("/").pop();
          }

          this.optionsCount[index] = option.getAttribute("data-id");
          
          // Try to set gallery immediately based on current option selection
          this.setGalleryBasedOnCurrentOptions();
          
          this.onOptionChange();
        });
      });
    });
  }

  fetchRecommendations() {
    const productId = this.dataset.productId;
    const container = document.querySelector(".js-upsell-wrapper");
    fetch(
      `/recommendations/products?section_id=wls-buybox-recommendations&product_id=${productId}`
    )
      .then((res) => res.text())
      .then((html) => {
        if (container) {
          container.innerHTML = html;
        }
      });
  }

  onSellingPlanChange() {
    const selectedPlan = this.sellingPlanSelect.value;

    this.addToCart.dataset.sellingPlanId = selectedPlan;
  }

  onQuantityChange() {
    const quantity = this.quantityPicker.value;

    this.addToCart.dataset.quantity = quantity;
  }

  onSubscriptionChange(event, onetime = false) {
    const target = event.target;
    const parent = target.closest(".js-selling-plans-wrapper");

    // Handle Active Classes
    this.sellingPlans.forEach((picker) => {
      picker.classList.remove("active");
    });
    parent.classList.add("active");

    // Change Prices
    const price = parent.dataset.price;
    const comparePrice = parent.dataset.compareAtPrice;

    this.price.innerHTML = price;
    this.comparePrice.innerHTML = `<del class="wls-title-h5 md:wls-title-h4">${comparePrice}</del>`;

    this.addToCart.dataset.sellingPlanId = parent.classList.contains("onetime")
      ? ""
      : this.sellingPlanSelect.value;
  }

  onOptionChange() {
    const options = this.optionsCount.map((option) => option).join(",");

    const params = new URLSearchParams(window.location.search);
    params.set("option_values", options);

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({}, "", newUrl);

    this.updateBuybox();
  }

  updateBuybox() {
    this.setAtcLoading(true);
    fetch(`?section_id=wls-buybox${window.location.search.replace('?', '&')}`)
      .then((response) => response.text())
      .then((htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        
        const newPriceSection = doc.querySelector(".js-prices");
        const priceSection = document.querySelector(".js-prices");
        if (newPriceSection && priceSection) {
          priceSection.innerHTML = newPriceSection.innerHTML;
        }

        const newColorTitle = doc.querySelector(
          '.wls-buybox__options-block-content .js-options-title'
        );
        const currentColorTitle = document.querySelector(
          '.wls-buybox__options-block-content .js-options-title'
        );
        if (newColorTitle && currentColorTitle) {
          currentColorTitle.innerHTML = newColorTitle.innerHTML;
        }

        this.setAtcLoading(false);
        const newAtcBtn = doc.querySelector(".wls-buybox__buttons-button");
        if (newAtcBtn && this.addToCart) {
          if(newAtcBtn.dataset.id){
            this.addToCart.dataset.id = newAtcBtn.dataset.id
          }

          if (!newAtcBtn.hasAttribute("disabled")) {
            this.addToCart.removeAttribute("disabled");
          } else {
            this.addToCart.setAttribute('disabled', 'disabled');
          }

          this.addToCart.innerHTML = newAtcBtn.innerHTML;

          this.addToCart.removeEventListener("click", this._atcHandler);
          if (!this.addToCart.disabled) {
            this._atcHandler = (e) => {
              e.preventDefault();
              this.onAddToCartClick();
            };
            this.addToCart.addEventListener("click", this._atcHandler);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching HTML:", error);
        this.setAtcLoading(false);
      })
              .finally(() => {
          // Update gallery to show the selected variant's image after DOM updates
          requestAnimationFrame(() => {
            this.setInitialGalleryImage();
          });
        })
  }



  onAddToCartClick() {
    if (this.addingToCart) return;
    this.addingToCart = true;
    const variantId = this.addToCart.dataset.id;
    const quantity = this.addToCart.dataset.quantity;
    const sellingPlanId = this.addToCart.dataset.sellingPlanId;
    let freeGiftQty = 0;
    if (quantity > 1) {
      freeGiftQty = Math.floor(quantity / 2);
    }
    console.log(variantId);

    this.handleAddToCartState("start");

    fetch(window.location.origin + "/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
          id: variantId,
          quantity: quantity
        }
        ],
      }),
    }).then((response) => {
      this.addingToCart = false;
      if (response.ok) {
        this.handleAddToCartState("success");
        this.refreshCart();
      }
    }).catch(() => {
      this.addingToCart = false;
    });
}

  handleAddToCartState(state) {
    const originalText =
      this.addToCart.dataset.originalText || this.addToCart.innerText;

    if (!this.addToCart.dataset.originalText) {
      this.addToCart.dataset.originalText = originalText;
    }

    if (state === "start") {
      this.addToCart.innerHTML = `
      <svg class="wls-buybox__button-loader" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2391_2305)">
          <rect x="5.83984" y="18.5684" width="2.25" height="2.25" rx="1.125" transform="rotate(-45 5.83984 18.5684)" fill="white"/>
        </g>
        <g clip-path="url(#clip1_2391_2305)">
          <rect x="11.873" y="22.0015" width="2.25" height="2.25" rx="1.125" transform="rotate(-90 11.873 22.0015)" fill="white"/>
        </g>
        <g clip-path="url(#clip2_2391_2305)">
          <rect x="18.5703" y="20.1594" width="2.25" height="2.25" rx="1.125" transform="rotate(-135 18.5703 20.1594)" fill="white"/>
        </g>
        <g clip-path="url(#clip3_2391_2305)">
          <rect x="22.002" y="14.1265" width="2.25" height="2.25" rx="1.125" transform="rotate(-180 22.002 14.1265)" fill="white"/>
        </g>
        <g clip-path="url(#clip4_2391_2305)">
          <rect x="20.1602" y="7.43164" width="2.25" height="2.25" rx="1.125" transform="rotate(135 20.1602 7.43164)" fill="white"/>
        </g>
        <g clip-path="url(#clip5_2391_2305)">
          <rect x="14.123" y="4.00146" width="2.25" height="2.25" rx="1.125" transform="rotate(90 14.123 4.00146)" fill="#F1D077"/>
        </g>
        <g clip-path="url(#clip6_2391_2305)">
          <rect x="7.43359" y="5.84033" width="2.25" height="2.25" rx="1.125" transform="rotate(45 7.43359 5.84033)" fill="white"/>
        </g>
        <g clip-path="url(#clip7_2391_2305)">
          <rect x="4.00195" y="11.8765" width="2.25" height="2.25" rx="1.125" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_2391_2305"><rect width="18" height="18" fill="white" transform="translate(0.271484 13) rotate(-45)"/></clipPath>
          <clipPath id="clip1_2391_2305"><rect width="18" height="18" fill="white" transform="translate(3.99805 22.0015) rotate(-90)"/></clipPath>
          <clipPath id="clip2_2391_2305"><rect width="18" height="18" fill="white" transform="translate(13.002 25.7278) rotate(-135)"/></clipPath>
          <clipPath id="clip3_2391_2305"><rect width="18" height="18" fill="white" transform="translate(22.002 22.0015) rotate(-180)"/></clipPath>
          <clipPath id="clip4_2391_2305"><rect width="18" height="18" fill="white" transform="translate(25.7285 13) rotate(135)"/></clipPath>
          <clipPath id="clip5_2391_2305"><rect width="18" height="18" fill="white" transform="translate(21.998 4.00146) rotate(90)"/></clipPath>
          <clipPath id="clip6_2391_2305"><rect width="18" height="18" fill="white" transform="translate(13.002 0.271973) rotate(45)"/></clipPath>
          <clipPath id="clip7_2391_2305"><rect width="18" height="18" fill="white" transform="translate(4.00195 4.00146)"/></clipPath>
        </defs>
      </svg>
      <span>Adding</span>
    `;
      this.addToCart.classList.add("adding-state");
    }

    if (state === "success") {
      this.addToCart.innerHTML = `<svg {{ icon_props }} width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 3.7L3.7 6.39999L9.09999 1" stroke="#F1D077" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Added</span>
            `;

      setTimeout(() => {
        this.addToCart.innerText = this.addToCart.dataset.originalText;
        this.addToCart.classList.remove("adding-state");
      }, 2000);
    }
  }

  refreshCart() {
    fetch("/?sections=cart-drawer")
      .then((res) => res.json())
      .then((data) => {
        const htmlString = data["cart-drawer"];
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        const newCartDrawer =
          doc.querySelector("cart-drawer") ||
          doc.querySelector("cart-drawer-renderer");

        const currentCartDrawer =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-drawer-renderer");

        if (newCartDrawer && currentCartDrawer) {
          currentCartDrawer.replaceWith(newCartDrawer);

          const header = document.querySelector("wls-header");
          if (header && header.handleCartIconClick) {
            header.elements.cartDrawer = newCartDrawer;
            requestAnimationFrame(() => {
              header.openCartDrawer();
            });
          } else if (typeof newCartDrawer.open === "function") {
            // Fallback for themes using the stock Dawn header/cart-drawer
            // (no <wls-header> component present).
            requestAnimationFrame(() => {
              newCartDrawer.open();
            });
          }
        }

        const countBubble = document.querySelector(
          ".wls-header__cart-icon-bubble"
        );
        if (countBubble) {
          fetch("/cart.js")
            .then((res) => res.json())
            .then((cartData) => {
              countBubble.textContent = cartData.item_count || "";
            });
        }
      })
      .catch((err) => console.error("Error refreshing cart:", err));
  }

  setGalleryBasedOnCurrentOptions() {
    if (!this.galleryThumbnails || !this.galleryMain) return false;
    
    // Find all currently selected options and try to match them with gallery images
    const selectedOptions = this.querySelectorAll('.js-option.selected');
    
    for (const selectedOption of selectedOptions) {
      const imgSrc = selectedOption.dataset.imgSrc;
      if (imgSrc && imgSrc !== 'null' && imgSrc !== '') {
        // Extract filename from the image source
        const optionURL = imgSrc.replace(/(&|\?)width=\d+/, "");
        const cleanSrc = optionURL.split("?")[0];
        const fileName = cleanSrc.split("/").pop();
        
        if (fileName) {
          // Find the corresponding thumbnail in the gallery
          const imageSelector = this.galleryThumbnails.querySelector(`img[src*="${fileName}"]`);
          if (imageSelector) {
            // Get the index of this thumbnail
            const thumbnails = Array.from(this.galleryThumbnails.querySelectorAll('.splide__slide'));
            const imageIndex = thumbnails.indexOf(imageSelector.closest('.splide__slide'));
            
            if (imageIndex !== -1) {
              // Set the gallery to show this image immediately
              this.setGalleryToImage(imageIndex);
              return true;
            }
          }
        }
      }
    }
    
    return false;
  }

  setInitialGalleryImage() {
    if (!this.galleryThumbnails || !this.galleryMain) return false;
    
    // Find the selected variant option
    let selectedOption = this.querySelector('.js-option.selected');
    
    // If no selected option found, try to find the default option based on data-default-option-id
    if (!selectedOption) {
      this.options.forEach((wrapper) => {
        const defaultOptionId = wrapper.dataset.defaultOptionId;
        if (defaultOptionId) {
          const defaultOption = wrapper.querySelector(`[data-id="${defaultOptionId}"]`);
          if (defaultOption) {
            selectedOption = defaultOption;
          }
        }
      });
    }
    
    if (!selectedOption) return false;
    
    const imgSrc = selectedOption.dataset.imgSrc;
    if (!imgSrc || imgSrc === 'null' || imgSrc === '') return false;
    
    // Extract filename from the image source
    const optionURL = imgSrc.replace(/(&|\?)width=\d+/, "");
    const cleanSrc = optionURL.split("?")[0];
    const fileName = cleanSrc.split("/").pop();
    
    if (!fileName) return false;
    
    // Find the corresponding thumbnail in the gallery
    const imageSelector = this.galleryThumbnails.querySelector(`img[src*="${fileName}"]`);
    if (imageSelector) {
      // Get the index of this thumbnail
      const thumbnails = Array.from(this.galleryThumbnails.querySelectorAll('.splide__slide'));
      const imageIndex = thumbnails.indexOf(imageSelector.closest('.splide__slide'));
      
      if (imageIndex !== -1) {
        // Set the gallery to show this image
        this.setGalleryToImage(imageIndex);
        return true; // Successfully set gallery
      }
    }
    
    return false; // Could not set gallery
  }

  setGalleryToImage(imageIndex) {
    if (!this.galleryMain || !this.galleryThumbnails) return;
    
    // Get the Splide instances
    const mainSlider = this.galleryMain.splide;
    const thumbSlider = this.galleryThumbnails.splide;
    
    if (mainSlider && thumbSlider) {
      // Go to the specific slide
      mainSlider.go(imageIndex);
      thumbSlider.go(imageIndex);
    } else {
      // If Splide instances are not ready yet, store the index and set it later
      this._pendingImageIndex = imageIndex;
    }
  }

  initGallery() {
    if (this.galleryMain && this.galleryThumbnails) {
      const gallerySlider = new Splide(this.galleryMain, {
        focus: "left",
        pagination: false,
        arrows: false,
      });

      const galleryThumbnails = new Splide(this.galleryThumbnails, {
        fixedWidth: 90,
        fixedHeight: 85,
        gap: 10,
        rewind: true,
        pagination: false,
        cover: false,
        arrows: false,
        isNavigation: true,
        breakpoints: {
          600: {
            fixedWidth: 60,
            fixedHeight: 44,
          },
        },
      });

      gallerySlider.sync(galleryThumbnails);
      gallerySlider.mount();
      galleryThumbnails.mount();
      
      // Store references to the Splide instances
      this.galleryMain.splide = gallerySlider;
      this.galleryThumbnails.splide = galleryThumbnails;
      
      // If there was a pending image index, set it now
      if (this._pendingImageIndex !== undefined) {
        this.setGalleryToImage(this._pendingImageIndex);
        this._pendingImageIndex = undefined;
      } else {
        // If no pending image, try to set initial gallery image
        this.setInitialGalleryImage();
      }
    }
  }


  initTabs() {
    const tabGroups = this.querySelectorAll(".wls-product-tabs");

    tabGroups.forEach((group) => {
      const buttons = group.querySelectorAll(".wls-product-tab-button");
      const contents = group.querySelectorAll(".wls-product-tab-content");
      if (!buttons.length || !contents.length) return;
      const tabNav = group.querySelector(".wls-product-tabs__nav");
      if (tabNav && window.innerWidth <= 768) {
        let isDown = false;
        let startX;
        let scrollLeft;

        tabNav.addEventListener("mousedown", (e) => {
          isDown = true;
          tabNav.classList.add("dragging");
          startX = e.pageX - tabNav.offsetLeft;
          scrollLeft = tabNav.scrollLeft;
        });

        tabNav.addEventListener("mouseleave", () => {
          isDown = false;
          tabNav.classList.remove("dragging");
        });

        tabNav.addEventListener("mouseup", () => {
          isDown = false;
          tabNav.classList.remove("dragging");
        });

        tabNav.addEventListener("mousemove", (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - tabNav.offsetLeft;
          const walk = (x - startX) * 1.1;
          tabNav.scrollLeft = scrollLeft - walk;
        });
      }

      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          const tab = button.dataset.tab;

          buttons.forEach((btn) => btn.classList.remove("active"));
          button.classList.add("active");

          contents.forEach((content) => {
            content.classList.remove("active");
          });

          const activeContent = group.querySelector(
            `.wls-product-tab-content[data-content="${tab}"]`
          );
          if (activeContent) {
            activeContent.classList.add("active");
          }
        });
      });
    });
  }
}

if (customElements.get("wls-buybox") === undefined) {
  customElements.define("wls-buybox", WLSBuybox);
}